<template>
  <div>
    <div class="single-course-sidebar">
      <div class="course-widget">
        <div class="sidebar-content">
          <!-- 💰 Fiyat -->
          <h3>{{ course.price }} ₺</h3>
          <a href="/contact" class="default-btn course-btn">Hemen Kaydol</a>

          <ul class="courses-details">
            <li>
              <div class="icon">
                <img src="../../assets/img/icon/user.svg" alt="icon" /> Eğitmen
              </div>
              <p>{{ course.instructor.name }}</p>
            </li>
            <li>
              <div class="icon">
                <img src="../../assets/img/icon/file2.svg" alt="icon" /> Ders Sayısı/Oturum
              </div>
              <p>{{ course.lessons }}</p>
            </li>
            <li>
              <div class="icon">
                <img src="../../assets/img/icon/clock.svg" alt="icon" /> Süre
              </div>
              <p>{{ course.duration }}</p>
            </li>
            <li>
              <div class="icon">
                <img src="../../assets/img/icon/star.svg" alt="icon" /> Seviye
              </div>
              <p>{{ course.level }}</p>
            </li>
            <li>
              <div class="icon">
                <img src="../../assets/img/icon/web.svg" alt="icon" /> Diller
              </div>
              <p>{{ course.language }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Popup Video -->
    <div class="popup-video" v-if="isPopup">
      <div class="d-table">
        <div class="d-table-cell">
          <div class="popup-overlay-close" @click="togglePopup">
            <div class="popup-overlay-close-line"></div>
            <div class="popup-overlay-close-line"></div>
          </div>
          <div class="play-video">
            <iframe src="https://www.youtube.com/embed/PWvPbGWVRrU" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Course } from "@/data/courseData";

export default defineComponent({
  name: "CourseSidebar",
  props: {
    course: {
      type: Object as PropType<Course>,
      required: true,
    },
  },
  data() {
    return { isPopup: false };
  },
  methods: {
    togglePopup() {
      this.isPopup = !this.isPopup;
    },
  },
});
</script>
